import SwalCustom from '../alert/swal-custom'

function SwalErrorCustom(error) {
  SwalCustom({
    title: error.response ? `CODE ${error.response.status}` : 'Not response',
    text: 'มีบางอย่างผิดพลาด โปรดลองเข้าใช้งานใหม่อีกครั้ง หรือ ติดต่อแผนกไอที',
    confirmButtonColor: 'red'
  })
}

export default SwalErrorCustom
